export default __webpack_public_path__ + "static/media/oldeuro-reversed.e1386c1d.svg";